import axiosClient from "api/axios_client.js";

const apiUser = {
  create: (payload) => axiosClient.post(`/user/create`, payload),
  update: (id, payload) => axiosClient.put(`/user/update/${id}`, payload),
  getAllClients: (payload) => axiosClient.post(`/user/get-all`, payload),
  getById: (id) => axiosClient.get(`/user/get-by-id/${id}`),
  delete: (ids) => axiosClient.delete(`/user/delete`, { data: { ids } }),
  updateStatus: (payload) => axiosClient.post(`/user/update-status`, payload),
  
  getCountries:()=>axiosClient.get(`/directories/business-master/country-directory/get-all`),
  getTrades:()=>axiosClient.get(`/directories/business-master/trade-of-work/get-all`),
  getBusinessTypes:()=>axiosClient.get(`/directories/business-master/business-type/get-all`),
  getDesignations:()=>axiosClient.get(`/directories/business-master/designation/get-all`),
  getCompanies:()=>axiosClient.get(`/companies/company-configuration/get-all`),
  getAllUserRoles: () => axiosClient.get(`/user-role-module/user-role/get-all`),
};

export default apiUser; 

